import { VToolbar } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VToolbar,{staticStyle:{"background":"#eee"},attrs:{"id":"core-toolbar","flat":"","prominent":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }